import { render } from "./FormCategorias.vue?vue&type=template&id=20049a72"
import script from "./FormCategorias.vue?vue&type=script&lang=js"
export * from "./FormCategorias.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__